export default __webpack_public_path__ + "static/media/pp.da261c96.png";